import type {
  AttachSessionAttachmentsBody,
  AttachSessionAttachmentsResponse,
  DeleteSessionAttachmentResponse,
  DiscardSessionResponse,
  GetActiveSessionResponse,
  GetSessionSnapshotResponse,
  OverrideEvaluationResponse,
  ReplaceSessionAttachmentBody,
  ReplaceSessionAttachmentResponse,
  SubmitSessionBody,
  SubmitSessionResponse,
  UploadingPolicyResponse,
} from "@nlc/shared-types";

import apiClient from "@/lib/api/client";

export function getActiveSession(
  requestId: number,
): Promise<GetActiveSessionResponse> {
  return apiClient
    .url("/uploading-sessions/")
    .query({ requestId })
    .get()
    .json<GetActiveSessionResponse>();
}

export function getSessionSnapshot(
  sessionId: string,
): Promise<GetSessionSnapshotResponse> {
  return apiClient
    .url(`/uploading-sessions/${sessionId}`)
    .get()
    .json<GetSessionSnapshotResponse>();
}

export function discardSession(
  sessionId: string,
): Promise<DiscardSessionResponse> {
  return apiClient
    .url(`/uploading-sessions/${sessionId}/discard`)
    .post({})
    .json<DiscardSessionResponse>();
}

export function submitSession(
  sessionId: string,
  body: SubmitSessionBody,
): Promise<SubmitSessionResponse> {
  return apiClient
    .url(`/uploading-sessions/${sessionId}/submit`)
    .post(body)
    .json<SubmitSessionResponse>();
}

export function deleteSessionAttachment(
  sessionId: string,
  attachmentId: number,
): Promise<DeleteSessionAttachmentResponse> {
  return apiClient
    .url(`/uploading-sessions/${sessionId}/attachments/${attachmentId}`)
    .delete()
    .json<DeleteSessionAttachmentResponse>();
}

export function overrideEvaluation(
  evaluationId: number,
): Promise<OverrideEvaluationResponse> {
  return apiClient
    .url(`/file-evaluations/${evaluationId}/override`)
    .post({})
    .json<OverrideEvaluationResponse>();
}

export function attachSessionAttachments(
  sessionId: string,
  body: AttachSessionAttachmentsBody,
): Promise<AttachSessionAttachmentsResponse> {
  return apiClient
    .url(`/uploading-sessions/${sessionId}/attachments`)
    .post(body)
    .json<AttachSessionAttachmentsResponse>();
}

export function getUploadingPolicy(
  requestId: number,
): Promise<UploadingPolicyResponse> {
  return apiClient
    .url(`/file-evaluations/${requestId}/uploading-policy`)
    .get()
    .json<UploadingPolicyResponse>();
}

export function replaceSessionAttachment(
  sessionId: string,
  attachmentId: number,
  body: ReplaceSessionAttachmentBody,
): Promise<ReplaceSessionAttachmentResponse> {
  return apiClient
    .url(`/uploading-sessions/${sessionId}/attachments/${attachmentId}/replace`)
    .post(body)
    .json<ReplaceSessionAttachmentResponse>();
}

export function renameAttachment(
  attachmentId: number,
  name: string,
): Promise<void> {
  return apiClient
    .url(`/attachments/${attachmentId}/name`)
    .patch({ name })
    .res()
    .then(() => {});
}
